export type TLiveView = 'business' | 'finance';

export interface ILiveTitlesUrlParams {
  liveView: TLiveView;
  gameTitle: string;
  isLegacy: boolean;
}

export const LIVE_TITLES_BASE_PATH = '/strategic/home';

/**
 * Parse Live Titles routing params from URL search string.
 * Canonical order: tab → subtitle → live_view → game_title
 */
export function parseLiveTitlesUrl(search: string): ILiveTitlesUrlParams {
  const normalizedSearch = search.startsWith('?') ? search.slice(1) : search;
  const params = new URLSearchParams(normalizedSearch);
  const subtitle = params.get('subtitle');
  const rawLiveView = params.get('live_view');
  const gameTitle =
    params.get('game_title') || params.get('studio_id') || 'all';

  const isLegacy = subtitle === 'titles' && !rawLiveView;
  const liveView: TLiveView =
    rawLiveView === 'finance' ? 'finance' : 'business';

  return { liveView, gameTitle, isLegacy };
}

export interface IBuildLiveTitlesUrlOptions {
  liveView: TLiveView;
  gameTitle?: string;
  tab?: string;
}

/**
 * Build canonical Live Titles URL with fixed param order.
 */
export function buildLiveTitlesUrl(
  options: IBuildLiveTitlesUrlOptions,
): string {
  const { liveView, gameTitle = 'all', tab = 'studio' } = options;
  const params = new URLSearchParams();
  params.set('tab', tab);
  params.set('subtitle', 'titles');
  params.set('live_view', liveView);
  params.set('game_title', gameTitle);
  return `${LIVE_TITLES_BASE_PATH}?${params.toString()}`;
}
